export const UPLOAD_CHART_MODAL = 'UPLOAD_CHART_MODAL';



// WEBPACK FOOTER //
// ./src/components/modal/modal-types.js